<template>
  <div class="main">
    <div class="pageTitle">
      <p>按个人查询</p>
      <div style="float:right">
        <currentDate @pageReadyFunc="pageReadyFunc"></currentDate>
      </div>
    </div>
    <div class="searchArea">
      <div class="weekly_search">
        <div class="search_input">
          <el-input v-model="listQueryByUser.Parameters.userName" autocomplete="off" readonly></el-input>
          <div class="input_chooseBtn" v-if="chooseUserAuthorization">
            <el-button type="text" size="medium" @click="showChooseUserView">选择</el-button>
            <el-button type="text" size="medium" @click="clearUser">清除</el-button>
          </div>
        </div>
        <div class="search_select">
          <el-select v-model="listQueryByUser.Parameters.startYear" placeholder class="selectYear">
            <el-option v-for="item in yearList" :key="item.id" :label="item.Name" :value="item.id"></el-option>
          </el-select>
          <el-select
            v-model="listQueryByUser.Parameters.startMonth"
            placeholder
            class="selectMonth">
            <el-option v-for="item in monthList" :key="item.id" :label="item.Name" :value="item.id"></el-option>
          </el-select>
        </div>
        <span>至</span>
        <div class="search_select">
          <el-select v-model="listQueryByUser.Parameters.endYear" placeholder class="selectYear">
            <el-option v-for="item in yearList" :key="item.id" :label="item.Name" :value="item.id"></el-option>
          </el-select>
          <el-select v-model="listQueryByUser.Parameters.endMonth" placeholder class="selectMonth">
            <el-option
              v-for="item in monthList"
              :key="item.id"
              :label="item.Name"
              :value="item.id"
              style="padding-left:10px;"
            ></el-option>
          </el-select>
        </div>
        <div class="searchBtnDiv">
          <el-button size="small" @click="searchTable">查询</el-button>
          <!-- <el-button type="text" class="defaultBtn" @click="downloadPort">下载</el-button> -->
        </div>
      </div>
    </div>
    <div class="tableContainer" style="top: 120px;">
      <div class="tableContent">
        <el-table :data="weekportList" border stripe>
          <el-table-column prop="organizationName" label="组织机构"></el-table-column>
          <el-table-column prop="userName" label="用户名称"></el-table-column>

          <el-table-column prop="year" label="年份"></el-table-column>
          <el-table-column prop="month" label="月份"></el-table-column>
          <el-table-column label="日期">
            <template slot-scope="props">
              <el-button type="text" size="mini" @click="showWeeklyReportView(props.row)">
                {{
                props.row.week
                }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="tablePagesNumber">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="listQueryByUser.PagingInfo.currentPage"
          :page-sizes="[10, 50, 100, 200]"
          :page-size="listQueryByUser.PagingInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="listQueryByUser.PagingInfo.totalCount"
        ></el-pagination>
      </div>
    </div>

    <weeklyReportView
      ref="weeklyReportView"
      :weeklyReportViewProps="weeklyReportViewProps"
      :currentLineInfo="currentLineInfo"></weeklyReportView>

    <chooseUser ref="chooseUser" :propsData="chooseUserPropsData" @chooseUserInfo="chooseUserCallback"></chooseUser>
    
  </div>
</template>
<script>
import { dateFtt } from "@/utils/auth.js";
import weeklyReportView from "../common/weeklyReportView";
import chooseUser from "../common/chooseUser";
import currentDate from "../common/currentDate";
export default {
  name: "weeklyReport",
  components: { weeklyReportView, chooseUser, currentDate },
  data() {
    return {
      currentWeekInfo: {},
      chooseUserPropsData: {
        visible: false
      },
      weeklyReportViewProps: {
        visible: false
      },
      listQueryByUser: {
        PagingInfo: {
          currentPage: 1,
          totalPage: 0,
          pageSize: 10,
          totalCount: 0
        },
        OrderBy: "",
        Parameters: {
          userId: this.$userContext.getUserId(),
          userName: this.$userContext.getUserName(),
          startYear: "",
          startMonth: "",
          endYear: "",
          endMonth: ""
        }
      },
      currentLineInfo: {},
      monthList: [
        { id: "1", name: "1" },
        { id: "2", name: "2" },
        { id: "3", name: "3" },
        { id: "4", name: "4" },
        { id: "5", name: "5" },
        { id: "6", name: "6" },
        { id: "7", name: "7" },
        { id: "8", name: "8" },
        { id: "9", name: "9" },
        { id: "10", name: "10" },
        { id: "11", name: "11" },
        { id: "12", name: "12" }
      ],
      yearList: [],
      weekportList: [],
      chooseUserAuthorization: false
    };
  },
  mounted() {
    this.checkAuthorizationAny();
    // this.pageReadyFunc();
  },
  filters: {
    weekDateShow: function(monday, sunday) {
      return dateFtt("MM/dd", monday) + " - " + dateFtt("MM/dd", sunday);
    },
    currentTimeShow: function(value) {
      return dateFtt("yyyy年MM月dd日 EEE ", new Date(value));
    },
    detailViewDateShow: function(value) {
      return dateFtt("yyyy-MM-dd", new Date(value));
    }
  },
  methods: {
    // 获取当前日期后的回调
    pageReadyFunc(currentWeekInfo) {
      this.currentWeekInfo = currentWeekInfo;
      this.listQueryByUser.Parameters.startYear = new Date(this.currentWeekInfo.now).getFullYear();
      this.listQueryByUser.Parameters.endYear = new Date(this.currentWeekInfo.now).getFullYear();
      this.listQueryByUser.Parameters.startMonth = new Date(this.currentWeekInfo.now).getMonth() + 1;
      this.listQueryByUser.Parameters.endMonth = new Date(this.currentWeekInfo.now).getMonth() + 1;
      //月份的数组不能超过当前月
      // this.monthList = this.monthList.slice(
      //   0,
      //   new Date(this.currentWeekInfo.now).getMonth() + 1
      // );
      this.getYearList();
      this.searchTable();
    },
    //获取权限
    checkAuthorizationAny() {
      this.chooseUserAuthorization = this.$userContext.checkAuthorizationAny(
        ["WeeklyReport_Search_ByUser_Scoped","WeeklyReport_Search_ByUser_All"]
        );
    },
    //获取时间
    getYearList() {
      this.$dateTimeHelperApi.getYearList().then(res => {
        if (res.data.successful) {
          this.yearList = [];
          let list = res.data.data;
          list.forEach(item => {
            this.yearList.push({ id: item, name: item });
          });
        } else {
          this.$alert(res.data.message, "提示");
        }
      });
    },
    searchTable() {
      if(this.listQueryByUser.Parameters.userId == null || this.listQueryByUser.Parameters.userId == ""){
        this.listQueryByUser.Parameters.userId = this.$userContext.getUserId();
        this.listQueryByUser.Parameters.userName = this.$userContext.getUserName();
      }

      this.$weeklyReportApi.getWeeklyReportList(this.listQueryByUser).then(res => {
        if (res.data.successful) {
          this.weekportList = res.data.data.data;
          this.weekportList.forEach(item => {
            item.week =
              dateFtt("MM/dd", item.monday) +
              "-" +
              dateFtt("MM/dd", item.sunday);
          });
          this.listQueryByUser.PagingInfo.totalCount =
            res.data.data.pagingInfo.totalCount;
        } else {
          this.$alert(res.data.message, "提示");
        }
      });
    },

    handleSizeChange(val) {
      this.listQueryByUser.PagingInfo.pageSize = val;
      this.searchTable();
    },
    handleCurrentChange(val) {
      this.listQueryByUser.PagingInfo.currentPage = val;
      this.searchTable();
    },

    //选择用户
    showChooseUserView() {
      let organizationId = "";

      if(this.$userContext.checkAuthorizationAny(["WeeklyReport_Search_ByUser_All"]) == false)
      {
           organizationId = this.$userContext.getOrganizationId();
      }

      this.$refs.chooseUser.show(organizationId);
    },
    chooseUserCallback(args) {
      this.listQueryByUser.Parameters.userId = args.id;
      this.listQueryByUser.Parameters.userName = args.name;
    },
    clearUser() {
      this.listQueryByUser.Parameters.userId = "";
      this.listQueryByUser.Parameters.userName = "";
    },

    showWeeklyReportView(current) {
      this.$refs.weeklyReportView.showById(current.id);
    },
   
    //下载报表，导出excel
    downloadPort() {

      if(this.listQueryByUser.Parameters.userId == null || this.listQueryByUser.Parameters.userId == ""){
        this.listQueryByUser.Parameters.userId = this.$userContext.getUserId();
        this.listQueryByUser.Parameters.userName = this.$userContext.getUserName();
      }

      let queryObj = {
        userId: this.listQueryByUser.Parameters.userId,
        startYear: this.listQueryByUser.Parameters.userstartYearId,
        startMonth: this.listQueryByUser.Parameters.startMonth,
        endYear: this.listQueryByUser.Parameters.endYear,
        endMonth: this.listQueryByUser.Parameters.endMonth
      };
      this.$weeklyReportApi.exportToExcelWeeklyReportCompleteListByUser(queryObj)
        .then(res => {
          if (res.data.successful) {
            window.open(window.Glob.BASE_URL + "/" + res.data.data);
          } else {
            this.$alert(res.data.message, "提示");
          }
        });
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.weekly_search {
  // display: inline-block;
  margin-top: 20px;
}
.search_input {
  width: 180px;
  position: relative;
  display: inline-block;
  margin-right: 10px;
}
.search_select {
  display: inline-block;
  margin-left: 20px;
}
.searchBtnDiv {
  display: inline-block;
}
.selectYear {
  width: 80px;
}
.selectMonth {
  width: 60px;
}
.selectMonth .el-input__inner,
.selectYear .el-input__inner {
  padding-left: 10px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/weeklyReport/user.vue